import { fetcher } from "utils";

import { GetMembersIssuedDiscountCouponsResponse, IPage } from "typings";

type GetMembersIssuedDiscountCoupons = (params?: { page: IPage }) => Promise<GetMembersIssuedDiscountCouponsResponse>;

export const get__members__issued_discount_coupons: GetMembersIssuedDiscountCoupons = (
  params = { page: { size: 100, number: 1 } }
) => fetcher.get("/members/issued_discount_coupons", params);
